export default {
  insuranceCarriers: '/seguradoras',
  insuranceCarrier(id: string) {
    return `${this.insuranceCarriers}/${id}`;
  },
};
